
<ng-container *ngIf="!property.PropertyIsEditable && !property.PropertyValue; else editor">
  <p>{{property.PropertyValue}}</p>
</ng-container>
<ng-template #editor>
  <quill-editor #quill [(ngModel)]="property.PropertyValue" [name]="property.PropertyName" (onBlur)="onValueChange(property.PropertyValue)" 
  [required]="property.PropertyValidation ? property.PropertyValidation.IsMandatory ? true : null : null" [modules]="modules"
  [readOnly]="!property.PropertyIsEditable">
    <div quill-editor-toolbar [class.disabled]="!property.PropertyIsEditable">
      <span class="ql-formats" [title]="'Font style'">
        <select class="ql-font">
          <option selected="selected"></option>
          <option value="serif"></option>
          <option value="monospace"></option>
        </select>
      </span>
      <span class="ql-formats" [title]="'Font format'">
        <select class="ql-size">
          <option value="small"></option>
          <option selected="selected"></option>
          <option value="large"></option>
          <option value="huge"></option>
        </select>
      </span>
      <span class="ql-formats">
        <button type="button" class="ql-bold" [title]="'Bold (Ctrl+B)'"></button>
        <button type="button" class="ql-italic" [title]="'Italic (Ctrl+I)'"></button>
        <button type="button" class="ql-underline" [title]="'Underline (Ctrl+U)'"></button>
        <button type="button" class="ql-strike" [title]="'Strike'"></button>
      </span>
      <span class="ql-formats">
        <button type="button" class="ql-list" value="ordered" [title]="'Numbered List'"></button>
        <button type="button" class="ql-list" value="bullet" [title]="'Bulleted List'"></button>
      </span>
      <span class="ql-formats">
        <span [title]="'Font colour'">
          <select class="ql-color">
            <option selected="selected"></option>
            <option value="#e60000"></option>
            <option value="#ff9900"></option>
            <option value="#ffff00"></option>
            <option value="#008a00"></option>
            <option value="#0066cc"></option>
            <option value="#9933ff"></option>
            <option value="#ffffff"></option>
            <option value="#facccc"></option>
            <option value="#ffebcc"></option>
            <option value="#ffffcc"></option>
            <option value="#cce8cc"></option>
            <option value="#cce0f5"></option>
            <option value="#ebd6ff"></option>
            <option value="#bbbbbb"></option>
            <option value="#f06666"></option>
            <option value="#ffc266"></option>
            <option value="#ffff66"></option>
            <option value="#66b966"></option>
            <option value="#66a3e0"></option>
            <option value="#c285ff"></option>
            <option value="#888888"></option>
            <option value="#a10000"></option>
            <option value="#b26b00"></option>
            <option value="#b2b200"></option>
            <option value="#006100"></option>
            <option value="#0047b2"></option>
            <option value="#6b24b2"></option>
            <option value="#444444"></option>
            <option value="#5c0000"></option>
            <option value="#663d00"></option>
            <option value="#666600"></option>
            <option value="#003700"></option>
            <option value="#002966"></option>
            <option value="#3d1466"></option>
          </select>
        </span>
        <span class="ql-bc" [title]="'Background colour'">
          <select class="ql-background">
              <option value="#000000"></option>
              <option value="#e60000"></option>
              <option value="#ff9900"></option>
              <option value="#ffff00"></option>
              <option value="#008a00"></option>
              <option value="#0066cc"></option>
              <option value="#9933ff"></option>
              <option selected="selected"></option>
              <option value="#facccc"></option>
              <option value="#ffebcc"></option>
              <option value="#ffffcc"></option>
              <option value="#cce8cc"></option>
              <option value="#cce0f5"></option>
              <option value="#ebd6ff"></option>
              <option value="#bbbbbb"></option>
              <option value="#f06666"></option>
              <option value="#ffc266"></option>
              <option value="#ffff66"></option>
              <option value="#66b966"></option>
              <option value="#66a3e0"></option>
              <option value="#c285ff"></option>
              <option value="#888888"></option>
              <option value="#a10000"></option>
              <option value="#b26b00"></option>
              <option value="#b2b200"></option>
              <option value="#006100"></option>
              <option value="#0047b2"></option>
              <option value="#6b24b2"></option>
              <option value="#444444"></option>
              <option value="#5c0000"></option>
              <option value="#663d00"></option>
              <option value="#666600"></option>
              <option value="#003700"></option>
              <option value="#002966"></option>
              <option value="#3d1466"></option>
          </select>
        </span>
      </span>
      <span class="ql-formats ql-alignment" [title]="'Text alignment'">
        <select class="ql-align">
            <option selected="selected" [title]="'Align left'"></option>
            <option value="center" [title]="'Align center'"></option>
            <option value="right" [title]="'Align right'"></option>
            <option value="justify" [title]="'Justify'"></option>
        </select>
      </span>
      <span class="ql-formats">
        <button type="button" class="ql-link" [title]="'Insert link'"></button>
      </span>
      <span class="ql-formats">
        <button type="button" class="ql-image" [title]="'Insert image'"></button>
      </span>
      <span class="ql-formats">
        <button type="button" class="ql-clean" [title]="'Clear formatting'"></button>
      </span>
    </div>
  </quill-editor>
</ng-template>